import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/hair-loss-blog/category/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/category/${params.slug}/`, statusCode: 301 });
  },
});
